export { default, links, meta } from "/Users/dallin/code/kuali/builder-ui/terraria-db/app/root.jsx";